import { getApolloContext } from '@apollo/client';
import { useContext } from 'react';

const useCache = () => {
  const { client } = useContext(getApolloContext());
  return { apolloCache: client?.cache };
};

export default useCache;
